import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => {
    return {
        selectStyle: {
            '&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                borderRadius: '4px',
                borderColor: theme.palette.grey.border,
                borderWidth: '1px',
            },
            '& .MuiInputBase-input': {
                width: 250,
                fontSize: '16px',
                [theme.breakpoints.up('sm')]: {
                    minWidth: 120,
                },
                [theme.breakpoints.down('sm')]: {
                    width: '100%',
                },
            },
            '&.Mui-focused > .MuiOutlinedInput-notchedOutline': {
                borderWidth: '2px',
                borderColor: theme.palette.primary.main,
            },
        },
    };
});

export default useStyles;

